import Blog from "../../components/Blog/Blog";
import Layout from "../../layout/Layout";
export default function Blogs() {
  return <Blog />;
}
